// Metodologia ufficiale P×D — Sicurgarda Scadenze
// Riferimento: "SEZ 7 METODOLOGIA DI VALUTAZIONE"
//
// Matrice 4×4 (P=1..4, D=1..4) → R = P × D ∈ {1,2,3,4,6,8,9,12,16}
//
// Classi:
//   R = 1        → molto basso  (miglioramenti programmabili, 180 gg)
//   2 ≤ R ≤ 4    → basso        (medio termine, 60 gg)
//   6 ≤ R ≤ 9    → medio        (con urgenza, 30 gg)
//   R ≥ 12       → alto         (immediato, 0 gg)
export function riskLevel(P, D) {
  const r = (Number(P) || 0) * (Number(D) || 0);
  if (r <= 0) return "";
  if (r === 1) return "molto_basso";
  if (r >= 2 && r <= 4) return "basso";
  if (r >= 6 && r <= 9) return "medio";
  return "alto";
}

// Etichetta human-readable italiana
export function riskLevelLabel(level) {
  switch (level) {
    case "molto_basso":
      return "molto basso";
    case "basso":
      return "basso";
    case "medio":
      return "medio";
    case "alto":
      return "alto";
    default:
      return "—";
  }
}

// Classi Tailwind coerenti tra tutti i moduli
export function riskLevelClasses(level) {
  switch (level) {
    case "molto_basso":
      return "bg-sky-100 text-sky-700 border-sky-200";
    case "basso":
      return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "medio":
      return "bg-amber-100 text-amber-700 border-amber-200";
    case "alto":
      return "bg-rose-100 text-rose-700 border-rose-200";
    default:
      return "bg-slate-100 text-slate-500 border-slate-200";
  }
}

// Tempo di intervento raccomandato in giorni
export function riskLevelDays(level) {
  switch (level) {
    case "molto_basso":
      return 180;
    case "basso":
      return 60;
    case "medio":
      return 30;
    case "alto":
      return 0;
    default:
      return null;
  }
}
